import { atom } from 'recoil'
import { SigmaCloudKeyResponseModel } from '@/domain/models'

export const selectSigmaCloudKeyData = atom({
  key: 'selectSigmaCloudKeyData',
  default: {} as SigmaCloudKeyResponseModel
})
